import { render, staticRenderFns } from "./recommendAction.vue?vue&type=template&id=1ea8e5a1&scoped=true&"
import script from "./recommendAction.vue?vue&type=script&lang=js&"
export * from "./recommendAction.vue?vue&type=script&lang=js&"
import style0 from "./recommendAction.vue?vue&type=style&index=0&id=1ea8e5a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea8e5a1",
  null
  
)

export default component.exports